import React from 'react';
import SeoMeta from '../components/SeoMeta';
import { PageBand, ClosingCta } from '../components/common/B2B';
import { CATEGORIES, articlesIn } from '../components/articles/articles';
import ArticleRows from '../components/articles/ArticleRows';

// Índice de artículos y guías (/articulos), nov-2026, diseño B2B: los artículos
// salen del registro (components/articles/articles.js), agrupados por categoría.
// Antes los enlaces de las guías se reescribían a /articulos/... (redirecciones);
// ahora van a su URL final.

const ArticulosPage = () => (
  <>
    <SeoMeta
      title="Artículos sobre documentos de transporte digitales | BlueCMR"
      description="Artículos sobre la normativa y la práctica de los documentos de transporte digitales: DeCA, carta de porte, eCMR, eFTI y firma electrónica."
      canonical="https://bluecmr.com/articulos"
      breadcrumbs={[
        { name: 'Inicio', url: 'https://bluecmr.com/' },
        { name: 'Artículos', url: 'https://bluecmr.com/articulos' },
      ]}
    />

    <div className="bg-white">
      <PageBand
        eyebrow="Recursos"
        title="Artículos"
        text="La normativa y la práctica de los documentos de transporte digitales, explicadas con claridad."
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 space-y-20">
        {CATEGORIES.map((cat) => (
          <section key={cat.slug} id={cat.slug} className="grid lg:grid-cols-12 gap-8 lg:gap-16 scroll-mt-24">
            <div className="lg:col-span-4">
              <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-slate-900">{cat.title}</h2>
              <p className="mt-3 text-slate-600 leading-relaxed">{cat.text}</p>
            </div>
            <div className="lg:col-span-8">
              <ArticleRows items={articlesIn(cat.slug)} />
            </div>
          </section>
        ))}

      </div>

      <ClosingCta title="¿Prefiere verlo funcionando?" text="Le enseñamos cómo resuelve BlueCMR sus documentos de transporte, sin compromiso." lang="es" />
    </div>
  </>
);

export default ArticulosPage;
